import { useMemo } from 'react'
import { useClientes } from './useClientes'

export interface ClienteNombre {
  id: string
  nombre: string
}

/**
 * Lista de clientes (id + nombre "Apellido, Nombre", ordenada por apellido) + lookup id→nombre.
 * Usa `nombre_formateado` de la vista (físicas: "Apellido, Nombre"; jurídicas: razón social).
 * Pensado para selects de filtro y columnas que sólo guardan `cliente_id`
 * (ej. planilla de mails de Auditoría, ORR-115 / ORR-161). Reusa `useClientes` (cacheado).
 */
export function useClienteNombres() {
  const { data: clientes } = useClientes()

  return useMemo(() => {
    const lista: ClienteNombre[] = (clientes ?? [])
      .filter((c) => c.id != null)
      .map((c) => ({
        id: c.id as string,
        // ORR-161: nombre_formateado = "Apellido, Nombre" (físicas) / razón social (jurídicas).
        nombre: c.nombre_formateado || c.nombre || 'Sin nombre',
      }))
      .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }))
    const mapa = new Map(lista.map((c) => [c.id, c.nombre]))
    return {
      clientes: lista,
      getNombre: (id: string | null | undefined): string | null => (id ? mapa.get(id) ?? null : null),
    }
  }, [clientes])
}
